// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.residence-modal-content {
    border-radius: 15px;
    width: 100%;
    max-width: 640px;
    min-height: 300px;
    padding: 2rem 1.5rem;
    position: relative;
    display: block;
    background: #fff;
}

.modal-close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 28px;
    line-height: 1;
    color: #000;
    cursor: pointer;
    opacity: 0.7;
    z-index: 10;
}
.modal-close-btn:hover {
    opacity: 1;
}

.residence-modal-body {
    padding: 0 1rem;
    padding-top: 1.5rem;
}

.modal-icon {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
}

.modal-icon img {
    width: 40px;
    height: 40px;
}

.form-title {
    padding-bottom: 1.5rem;
}

.form-title h4,
.form-title h4.modal-title {
    font-family: "Montserrat", sans-serif !important;
    font-weight: 600 !important;
    font-size: 30px !important;
    line-height: 100% !important;
    letter-spacing: 0px !important;
    text-align: center !important;
    color: #000 !important;
    margin-bottom: 2rem !important;
}

.form-title .textcolor,
.form-title p.textcolor {
    font-family: "Montserrat", sans-serif !important;
    font-weight: 400 !important;
    font-size: 22px !important;
    line-height: 100% !important;
    letter-spacing: 0px !important;
    text-align: center !important;
    color: #0A0A0A !important;
}

.checkbox-container {
    margin: 1.5rem 0;
    display: flex;
    justify-content: center;
}

.checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.checkbox-input {
    margin-right: 8px;
    cursor: pointer;
    width: 18px;
    height: 18px;
}

.checkbox-text {
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    color: #000000;
}

.button-container {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-top: 1rem;
}

.btn {
    width: 100%;
    max-width: 450px;
    border-radius: 50px;
    color: white;
    margin: 0 auto;
    cursor: pointer;
    display: block;
    padding: 0.5rem 1rem;
    min-height: 45px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    transition: opacity 0.3s;
}

.btn:hover {
    opacity: 0.9;
}

.btn-primary {
    background: #000000;
    color: #FFFFFF;
    border-radius: 12.73px;
}

.btn-secondary {
    background: #6c757d;
}

.btn-text-link {
    background: transparent !important;
    border: none;
    color: #000;
    font-weight: 700 !important;
    padding: 10.18px 20px;
    min-height: 42px;
    width: 210px;
    max-width: 100%;
    border-radius: 12.73px;
    gap: 12.73px;
    opacity: 1;
}

/* Optimización para móvil */
@media screen and (max-width: 768px) {
    .residence-modal-content {
        max-width: 99%;
        width: 99%;
        min-height: 280px;
        padding: 0.8rem 0.8rem;
        margin: 0 auto;
    }
    
    .residence-modal-body {
        padding: 1rem;
        padding-top: 1rem;
    }
    
    .form-title h4,
    .form-title h4.modal-title {
        font-size: 22px !important;
    }
    
    .form-title .textcolor,
    .form-title p.textcolor {
        font-size: 18px !important;
    }
    
    .btn {
        padding: 0.4rem 1rem;
        font-size: 16px;
        min-height: 40px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/modal-residence-certificate/modal-residence-certificate.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,gDAAgD;IAChD,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;IAC7B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;;IAEI,gDAAgD;IAChD,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,UAAU;AACd;;AAEA,4BAA4B;AAC5B;IACI;QACI,cAAc;QACd,UAAU;QACV,iBAAiB;QACjB,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".residence-modal-content {\n    border-radius: 15px;\n    width: 100%;\n    max-width: 640px;\n    min-height: 300px;\n    padding: 2rem 1.5rem;\n    position: relative;\n    display: block;\n    background: #fff;\n}\n\n.modal-close-btn {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    font-size: 28px;\n    line-height: 1;\n    color: #000;\n    cursor: pointer;\n    opacity: 0.7;\n    z-index: 10;\n}\n.modal-close-btn:hover {\n    opacity: 1;\n}\n\n.residence-modal-body {\n    padding: 0 1rem;\n    padding-top: 1.5rem;\n}\n\n.modal-icon {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 2rem;\n}\n\n.modal-icon img {\n    width: 40px;\n    height: 40px;\n}\n\n.form-title {\n    padding-bottom: 1.5rem;\n}\n\n.form-title h4,\n.form-title h4.modal-title {\n    font-family: \"Montserrat\", sans-serif !important;\n    font-weight: 600 !important;\n    font-size: 30px !important;\n    line-height: 100% !important;\n    letter-spacing: 0px !important;\n    text-align: center !important;\n    color: #000 !important;\n    margin-bottom: 2rem !important;\n}\n\n.form-title .textcolor,\n.form-title p.textcolor {\n    font-family: \"Montserrat\", sans-serif !important;\n    font-weight: 400 !important;\n    font-size: 22px !important;\n    line-height: 100% !important;\n    letter-spacing: 0px !important;\n    text-align: center !important;\n    color: #0A0A0A !important;\n}\n\n.checkbox-container {\n    margin: 1.5rem 0;\n    display: flex;\n    justify-content: center;\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n}\n\n.checkbox-input {\n    margin-right: 8px;\n    cursor: pointer;\n    width: 18px;\n    height: 18px;\n}\n\n.checkbox-text {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    text-align: center;\n    color: #000000;\n}\n\n.button-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    margin-top: 1rem;\n}\n\n.btn {\n    width: 100%;\n    max-width: 450px;\n    border-radius: 50px;\n    color: white;\n    margin: 0 auto;\n    cursor: pointer;\n    display: block;\n    padding: 0.5rem 1rem;\n    min-height: 45px;\n    font-size: 16px;\n    font-weight: bold;\n    border: none;\n    transition: opacity 0.3s;\n}\n\n.btn:hover {\n    opacity: 0.9;\n}\n\n.btn-primary {\n    background: #000000;\n    color: #FFFFFF;\n    border-radius: 12.73px;\n}\n\n.btn-secondary {\n    background: #6c757d;\n}\n\n.btn-text-link {\n    background: transparent !important;\n    border: none;\n    color: #000;\n    font-weight: 700 !important;\n    padding: 10.18px 20px;\n    min-height: 42px;\n    width: 210px;\n    max-width: 100%;\n    border-radius: 12.73px;\n    gap: 12.73px;\n    opacity: 1;\n}\n\n/* Optimización para móvil */\n@media screen and (max-width: 768px) {\n    .residence-modal-content {\n        max-width: 99%;\n        width: 99%;\n        min-height: 280px;\n        padding: 0.8rem 0.8rem;\n        margin: 0 auto;\n    }\n    \n    .residence-modal-body {\n        padding: 1rem;\n        padding-top: 1rem;\n    }\n    \n    .form-title h4,\n    .form-title h4.modal-title {\n        font-size: 22px !important;\n    }\n    \n    .form-title .textcolor,\n    .form-title p.textcolor {\n        font-size: 18px !important;\n    }\n    \n    .btn {\n        padding: 0.4rem 1rem;\n        font-size: 16px;\n        min-height: 40px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
